import { useState, useEffect } from 'react'
import StatusBadge from '../components/StatusBadge'
import ProgressBar from '../components/ProgressBar'
import { api } from '../lib/api'

const jobTypeLabels: Record<string, string> = {
  transcript: '📝 سحب ترانسكريبت',
  translate: '🌐 ترجمة',
  manufacture: '⚙️ تصنيع M1-M5',
  product: '📦 إنتاج منتج',
}

export default function Queue() {
  const [jobs, setJobs] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function load() {
      try {
        const data = await api.getQueueStatus()
        setJobs(data)
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  if (loading) return <div className="text-center text-gray-400 py-12">جاري التحميل...</div>

  const processing = jobs.filter(j => j.status === 'processing').length
  const queued = jobs.filter(j => j.status === 'queued').length
  const completed = jobs.filter(j => j.status === 'complete').length

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-vertex-gold">طابور المعالجة</h2>
        <div className="flex gap-4 text-xs">
          <span className="text-blue-400">⏳ جاري: {processing}</span>
          <span className="text-yellow-400">📋 منتظر: {queued}</span>
          <span className="text-green-400">✅ مكتمل: {completed}</span>
        </div>
      </div>

      <div className="bg-vertex-navy rounded-lg border border-vertex-surface overflow-hidden">
        {jobs.length === 0 ? (
          <div className="p-8 text-center text-gray-500 text-sm">
            لا توجد مهام في الطابور حالياً
          </div>
        ) : (
          <div className="divide-y divide-vertex-surface">
            {jobs.map((job) => (
              <div key={job.id} className="p-4 flex items-center gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-bold">{job.lecture_title || 'محاضرة'}</span>
                    <span className="text-xs text-gray-400">{jobTypeLabels[job.job_type] || job.job_type}</span>
                  </div>
                  {job.status === 'processing' && (
                    <ProgressBar value={job.progress || 0} showPercent />
                  )}
                </div>
                <StatusBadge status={job.status} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
